import { render, staticRenderFns } from "./newsxiangqing.vue?vue&type=template&id=17afa78a&scoped=true&"
import script from "./newsxiangqing.vue?vue&type=script&lang=js&"
export * from "./newsxiangqing.vue?vue&type=script&lang=js&"
import style0 from "./newsxiangqing.vue?vue&type=style&index=0&id=17afa78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afa78a",
  null
  
)

export default component.exports